import { Injectable } from "@angular/core"
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router"
import { Observable } from "rxjs";
import Rutas from "./Models/Base/rutas";
import { AppStateService } from "./Services/AppState/app-state.service";

@Injectable({
    providedIn: 'root'
    })
    export class SessionGuard  {
    
    constructor(
        private appStateService: AppStateService
        , private router: Router
    ) {}
    
    canActivate(
        route: ActivatedRouteSnapshot
        , state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if(this.appStateService.IsAuthGuard())
            return true;
        else
            return this.router.navigate([Rutas.LOGIN])
    }
    
    
}